











import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import OnClickOutside from './OnClickOutside.vue';

@Component({
  components: {
    OnClickOutside,
  },
})
export default class Menu extends Vue {
  private open: boolean = false;

  @Prop({default: false}) private showMenu!: boolean;
  @Prop({ default: '' }) private wrapperClass!: string;
  @Prop({ default: 'top-100 right-0' }) private dropdownPosition!: string;
  @Prop({ default: 'min-w-200' }) private dropdownWidth!: string;
  @Prop({ default: 'bg-white' }) private dropdownBackground!: string;
  @Prop({ default: 'text-sm'}) private dropdownText!: string;

  @Watch('showMenu')
  public onShowMenuChanged(showMenu: boolean) {
    this.open = showMenu;
  }

  public handleClickOutside() {
    if (this.open) {
      this.$emit('Menu:menuShown', false);
      this.open = false;
    }
  }
}
